import styled from "styled-components";
import { HXButton, HXMobileButton } from "./HXButton";
export const HXMenuButtonEl = styled(HXButton) `
    display: inline-flex;
`;
export const HXMobileMenuButtonEl = styled(HXMobileButton) `
    display: inline-flex;
`;
